'use client'

import { useState } from 'react'
import Image, { type ImageProps } from 'next/image'

import { siteUrl } from '@/lib/config'
import { normaliseMediaSrc } from '@/lib/media-src'
import { cn } from '@/lib/utils'

/**
 * Site-wide image wrapper. Behaves exactly like `next/image` but fades the
 * image in (opacity 0 → 1) once the browser reports it loaded. Priority
 * images skip the fade so above-the-fold LCP candidates render instantly.
 */
export function MediaImage({ className, onLoad, priority, ...props }: ImageProps) {
  const [loaded, setLoaded] = useState(false)
  const skipFade = priority

  return (
    // alt is forwarded via {...props}; jsx-a11y can't see through spread.
    // eslint-disable-next-line jsx-a11y/alt-text
    <Image
      {...props}
      src={normaliseMediaSrc(props.src, siteUrl)}
      priority={priority}
      onLoad={(event) => {
        setLoaded(true)
        onLoad?.(event)
      }}
      className={cn(
        !skipFade && 'transition-opacity duration-500 ease-out',
        !skipFade && (loaded ? 'opacity-100' : 'opacity-0'),
        className
      )}
    />
  )
}
